import axios from './axiosConfig'

export const notificationsAPI = {
 getAll: async (params?: any) => {
 const response = await axios.get('/notifications', { params })
 return response.data
 },

 getSummary: async () => {
 const response = await axios.get('/notifications/summary')
 return response.data
 },

 getUnreadCount: async () => {
 const response = await axios.get('/notifications/unread-count')
 return response.data
 },

 markAsRead: async (id: number) => {
 const response = await axios.post(`/notifications/${id}/read`)
 return response.data
 },

 markAllAsRead: async () => {
 const response = await axios.post('/notifications/read-all')
 return response.data
 },

 delete: async (id: number) => {
 const response = await axios.delete(`/notifications/${id}`)
 return response.data
 },

 clearAll: async () => {
 const response = await axios.delete('/notifications')
 return response.data
 },
}
